import type { Container } from '@sbclite/core';
import { DependencyChecklistCard } from './DependencyChecklistCard';
import { buildContainerPreflightModel } from '@/lib/preflight-checklist';

export function EnginePrerequisitesCard({
  report,
  title = 'Engine prerequisites',
  subtitle = 'Database-backed readiness checks for the active container.',
}: {
  readonly report: Container.ContainerPrerequisiteReport;
  readonly title?: string;
  readonly subtitle?: string;
}) {
  return <DependencyChecklistCard model={buildContainerPreflightModel(report)} title={title} subtitle={subtitle} />;
}
